
export default class Deferred {
    constructor () {
        this.promise = new Promise((resolve, reject) => {
            this.reject = reject
            this.resolve = resolve
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/deferred.js